module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/18-0aaf04eb2ba7ab2f913e263c83be4762.jpg";